import React from 'react'
import { mainImage, mainImageOuter, akosLogo, appStoreImg, playStoreImg } from '../assets';
import { Typography, Grid } from '@mui/material';
const SubMainComponent = () => {
    return (
        <>
            <div style={{ position: "relative", height: "100vh", backgroundColor: '#024C9C' }}>
                <img src={mainImage} alt="mainImg" width="100%" height="100%" style={{ opacity: '14%' }} />
                <div style={{
                    position: 'absolute',
                    top: '10%',
                    left: '20%'
                }}>
                    <img src={akosLogo} width='100%' height="5%" />
                </div>
                <div style={{
                    position: 'absolute',
                    top: '25%',
                    left: '20%'
                }}>
                    <Typography style={{
                        fontSize: '62px', color: 'white', fontFamily: 'Playfair Display',
                        fontStyle: 'italic',
                        fontWeight: '700',
                        lineHeight: '60px',
                        color: '#FFFFFF',
                    }}>{`Virtual`}</Typography>
                    <Typography style={{
                        fontSize: '62px', color: 'white', fontFamily: 'Playfair Display',
                        fontStyle: 'italic',
                        fontWeight: '700',
                        lineHeight: '60px',
                        color: '#FFFFFF',
                    }}>{`Urgent Care`}</Typography>
                </div>
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '20%',
                    right: '5%'
                }}>
                    <div style={{ display: 'flex' }}>
                        <Typography style={{
                            fontSize: '28px', color: 'white', fontFamily: 'manrope',
                            fontStyle: 'normal',
                            fontWeight: '700',
                            //lineHeight: '60px',
                            color: '#FFFFFF',
                        }}>Download AkosMD App </Typography>
                    </div>
                    <div style={{ display: 'flex', width: '65%', justifyContent: 'space-between', marginTop: '5%' }}>
                        <img src={appStoreImg} style={{ cursor: 'pointer', width: '45%' }} onClick={(e) => { e.preventDefault(); window.location.href = 'https://apps.apple.com/us/app/akos/id1187895369' }} //{() => window.open('https://apps.apple.com/us/app/akos/id1187895369')} 
                        />
                        <img src={playStoreImg} style={{ cursor: 'pointer', width: '45%' }} onClick={(e) => { e.preventDefault(); window.location.href = 'https://play.google.com/store/apps/details?id=com.akosmd.patientapp&hl=en_IN&gl=US&pli=1' }} />
                    </div>
                </div>
                <Grid container style={{
                    position: 'absolute',
                    bottom: '10%',
                    left: '10%',
                    flexDirection: 'row',
                    width: '80%',
                    justifyContent: 'space-between'
                }}>
                    <div>
                        <p style={{ fontFamily: 'manrope', color: '#FFFFFF', display: "inline", textDecoration: 'none' }}>{`1.844.900.AKOS(2567) `}</p>
                        <p style={{
                            fontFamily: 'manrope', color: '#FFFFFF', display: "inline", textDecoration: 'none',
                        }}>| info@akosmd.com</p></div>
                    <div>
                        <p style={{ fontFamily: 'manrope', color: '#FFFFFF', display: "inline", textDecoration: 'none' }}>{`Copyright ©2022 Akos `}</p>
                        <p style={{
                            fontFamily: 'manrope', color: '#FFFFFF', display: "inline", textDecoration: 'none'
                        }}>| All Rights Reserved</p></div>
                </Grid>
                {/* <div 
                    style={{
                        //position: 'absolute',
                        //bottom: '5%',
                        //right: '5%',
                        //left: '20%',
                        //flexDirection: 'row'
                    }}
                    >
                        <p style={{ fontFamily: 'manrope', color: '#FFFFFF', display: "inline", textDecoration: 'none' }}>{`Copyright ©2022 Akos `}</p>
                        <p style={{
                            fontFamily: 'manrope', color: '#FFFFFF', display: "inline", textDecoration: 'none'
                        }}>| All Rights Reserved</p>

                    </div> */}
            </div>
        </>
    )
}

export default SubMainComponent
